import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DepartmentsResDto } from '../_dtos/departmentsResDto';
import { DepartmentResDto } from '../_dtos/departmentResDto';

@Injectable({
  providedIn: 'root',
})
export class DepartmentsService {
  private readonly apiUrl = `${environment.backendBaseUrl}/departments`;
  private departments = new BehaviorSubject<DepartmentResDto[] | null>(null);
  private department = new BehaviorSubject<DepartmentResDto | null>(null);

  departments$ = this.departments.asObservable();
  defaultDepartment$ = this.department.asObservable();

  constructor(private http: HttpClient) {}

  getDepartmentsObservable(): Observable<DepartmentsResDto> {
    return this.http.get<DepartmentsResDto>(this.apiUrl);
  }

  getDepartmentObservable(department: string): Observable<DepartmentResDto> {
    const url = `${this.apiUrl}?internalName=${department}`;
    return this.http.get<DepartmentResDto>(url);
  }

  getDepartments(): DepartmentResDto[] {
    const deps = this.departments.getValue();
    if (!deps)
      throw new Error('Attempted to access departments before it was loaded');

    return deps;
  }

  getDepartment(): DepartmentResDto {
    const dep = this.department.getValue();
    if (!dep)
      throw new Error('Attempted to access department before it was loaded');

    return dep;
  }

  setDepartments(departments: DepartmentResDto[]) {
    this.departments.next(departments);
  }

  setDepartment(department: DepartmentResDto) {
    this.department.next(department);
  }
}
